<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/om-aschehoug" />
</template>
